export default __webpack_public_path__ + "3849efbaa1975b80b09b9a1038b88766.jpg";